import { Injectable, InjectionToken, ValueProvider, Inject } from '@angular/core';
import { SemafoneConfig } from './semafone-config.model';

export const SEMAFONE_CONFIG = new InjectionToken<SemafoneConfig>('SemafoneConfigService');

@Injectable({
  providedIn: 'root',
})
export class SemafoneConfigService {
  static configure(config?: SemafoneConfig): ValueProvider {
    return {
      provide: SEMAFONE_CONFIG,
      useValue: config || {},
    };
  }
  constructor(@Inject(SEMAFONE_CONFIG) public config: SemafoneConfig) {}
}
